import { authHeaders, fetchWithAuthRetry, getApiUrl, parseApiError } from './common';

export type SearchReindexStatus = {
  status: 'idle' | 'running' | 'done' | 'error';
  isConfigured: boolean;
  // 마지막 실패 지점부터 이어서 재색인할 수 있으면 true(status='error'일 때만).
  canResume: boolean;
  startedAt: string | null;
  finishedAt: string | null;
  entityCount: number;
  entityTotal: number;
  chunkCount: number;
  tokenCount: number;
  error: string | null;
  triggeredByMemberId: string | null;
};

type SearchReindexStatusResponse = { data: SearchReindexStatus };

export const fetchSearchReindexStatus = async (token: string): Promise<SearchReindexStatus> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/admin/search/reindex/status`, {
    cache: 'no-store',
    headers: authHeaders(token),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to fetch search reindex status: ${response.status}`);
  }

  return ((await response.json()) as SearchReindexStatusResponse).data;
};

// resume=true면 마지막 실패 지점부터 전량 삭제 없이 이어서 재색인한다.
export const triggerSearchReindex = async (token: string, resume = false): Promise<SearchReindexStatus> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/admin/search/reindex`, {
    method: 'POST',
    headers: { ...authHeaders(token), 'content-type': 'application/json' },
    body: JSON.stringify({ resume }),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to start search reindex: ${response.status}`);
  }

  return ((await response.json()) as SearchReindexStatusResponse).data;
};
